<template>
  <div>
    <b-modal
      id="modalLot"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      size="xl"
      :title="titleModal"
    >
      <template #default>
        <b-alert
          :show="customErrorMessage !== null"
          dismissible
          variant="danger"
        >
          <span v-html="customErrorMessage"></span>
        </b-alert>
        <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label for="lot"
                  >N° Lot <span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  :class="{
                    'is-invalid': form.errors.has('lot'),
                  }"
                  id="lot"
                  v-model="form.lot"
                  type="text"
                  placeholder="N° Lot"
                  maxlength="30"
                  required
                />
                <has-error :form="form" field="lot"></has-error>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="dlc">DLC <span class="text-danger">*</span></label>
                <date-picker
                  v-model="form.dlc"
                  name="dlc"
                  placeholder="DLC"
                  lang="fr"
                  format="DD/MM/YYYY"
                  value-type="DD/MM/YYYY"
                ></date-picker>
                <input
                  class="form-control"
                  :class="{
                    'is-invalid': form.errors.has('dlc'),
                  }"
                  type="hidden"
                />
                <has-error :form="form" field="dlc"></has-error>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="dluo"
                  >DLUO <span class="text-danger">*</span></label
                >
                <date-picker
                  v-model="form.dluo"
                  name="dluo"
                  placeholder="DLUO"
                  lang="fr"
                  format="DD/MM/YYYY"
                  value-type="DD/MM/YYYY"
                ></date-picker>
                <input
                  class="form-control"
                  :class="{
                    'is-invalid': form.errors.has('dluo'),
                  }"
                  type="hidden"
                />
                <has-error :form="form" field="dluo"></has-error>
              </div>
            </div>
          </div>
        </form>
      </template>
      <template #modal-footer>
        <button
          type="button"
          class="btn btn-danger mr-2"
          @click="$bvModal.hide('modalLot')"
        >
          Fermer
        </button>

        <button
          type="submit"
          class="btn btn-custom-primary w-40"
          @click="submit"
          style="min-width: 100px"
        >
          Ajouter
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Form from 'vform';
import DatePicker from 'vue2-datepicker';
export default {
  data() {
    return {
      form: new Form({
        lot: null,
        dlc: null,
        dluo: null,
      }),
      titleModal: 'Ajout de nouveau Lot',
      customErrorMessage: null,
    };
  },
  components: {
    DatePicker,
  },
  props: ['currentItem'],
  methods: {
    showModal() {
      this.customErrorMessage = null;
      this.form.reset();
      this.form.clear();

      this.form.lot = this.currentItem.lot;
      this.form.dlc = this.currentItem.dlc;
      this.form.dluo = this.currentItem.dluo;

      this.$bvModal.show('modalLot');
    },

    submit() {
      this.customErrorMessage = null;
      if (this.articleId) this.form.article_id = this.articleId;
      this.$bvModal.hide('modalLot');

      this.$emit(
        'onAddNewLot',
        this.currentItem,
        this.form.lot,
        this.form.dlc,
        this.form.dluo
      );
    },
  },
};
</script>

<style scoped lang="scss"></style>
